import React from "react";

const Content: React.FC = () => {
  return (
    <>
      
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>
      <group data-radius="20" data-ratio="1:1" data-align="center" data-justify="center" data-background="highlight"></group>

    </>
  );
};
export default Content;
